<style>
.el-popover{
  word-break: break-word !important;
}
.el-tabs--border-card>.el-tabs__content{
  padding: 0px !important;
}
.el-dialog__header{
  padding: 0px !important;
  font-weight: bold !important;
}
.el-dialog--center .el-dialog__body{
  padding: 10px !important;
}

 .el-icon-warning:before {
 color:#F56C6C!important;
 }

</style>
<template>
  <div>
    <div style="margin-right: 5px;margin-left: 5px;margin-top: 10px;border: 2px solid #eef1f6">
      <div style="padding-left: 20px;padding-top: 5px;padding-bottom: 10px;
      font-weight: bold;background-color:#eef1f6 "><a style="font-size: 1.3rem;margin: 0;color: black">Detail </a>
        <a style="font-size: 1.2rem;margin: 0;color: #0e63bb;padding-left: 5px"> ({{input}}; Component type: {{tableData[0].Components_type}})</a>
      </div>

      <div style="margin: 5px;border: 2px solid #eef1f6;overflow-y:auto;">
              <div style="padding-left: 20px;padding-top: 3px;padding-bottom: 10px;margin: 0;
                font-weight: bold;background-color:#eef1f6 ;"><a style="font-size: 1.1rem;margin: 0;color: #409EFF">RNA(s) information </a>
              </div>

              <div style="font-size: 0.9rem;padding-left: 0px">

                <el-table              :data="tableData2"
                                       border
                                       :cell-style="{background:'white',color: 'black',fontSize: '0.9rem'}"
                                       :header-cell-style="{background:'#F5F7FA',color:'black',fontSize:'0.9rem'}"
                                       >

                  <el-table-column
                      prop="Rna"
                      label="RNA(s)"
                      align= "center"
                  >
                    <template slot-scope="scope">
                      <router-link v-show="scope.row.Rnaother!='-'" style="color: #0e63bb;font-weight: bold"  v-bind:to="/Annotation/+scope.row.Rnaother">{{scope.row.Rna}}  <i class="el-icon-d-arrow-right" style="font-size:0.9rem;font-weight: bolder;"></i></router-link>
                      <a v-show="scope.row.Rnaother=='-'" style="color: #0e63bb;font-weight: bold">{{scope.row.Rna}}</a>
                    </template>

                  </el-table-column>

                  <el-table-column
                      prop="rnaid"
                      label="RNAID"
                      align= "center"
                  >
                    <template slot-scope="scope">
                      <a v-show="scope.row.rnalink!='-'" style="color: #0e63bb" target="_blank" v-bind:href='scope.row.rnalink'>{{scope.row.rnaid}}</a>
                      <a v-show="scope.row.rnalink=='-'" style="color: black" >{{scope.row.rnaid}}</a>
                    </template>
                  </el-table-column>

                  <el-table-column
                      prop="RNA_length"
                      label="Length"
                      align= "center"
                  >
                  </el-table-column>

                  <el-table-column
                      prop="RNA_Classification"
                      label="Type"
                      align= "center"
                  >
                  </el-table-column>

                  <el-table-column
                      prop="RNA_source"
                      label="Species"
                      align= "center"
                  >
                  </el-table-column>

                  <el-table-column
                      prop="RNA_Sequence"
                      label="Sequence "
                      align= "center"
                      :render-header="renderHeade"
                  >
                    <template slot-scope="scope">
                      <a v-show="scope.row.RNA_Sequence=='-'">-</a>
                      <el-popover
                          placement="top-start"
                          title="Sequence "
                          width="610"
                          trigger="hover"
                          v-show="scope.row.RNA_Sequence!='-'"
                          >
                        <div v-html="scope.row.RNA_Sequence"></div>
                        <el-button slot="reference" size="mini" style="background-color: #eef1f6;color: #0e63bb;font-size: 0.6rem">show</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>

                  <el-table-column
                      prop="structure"
                      label="Structure"
                      align= "center"
                  >
                    <template slot-scope="scope">
                      <a v-show="scope.row.structure=='-'">-</a>

                        <el-button  v-show="scope.row.structure!='-'"  @click.native.prevent="isViewPdf (scope.row)" slot="reference" size="mini" style="background-color: #eef1f6;color: #0e63bb;font-size: 0.6rem">click</el-button>
                      <el-dialog
                          :title='stname+" structure"'
                          :visible.sync="isViewPdf20"
                          :fullscreen="false"
                          center
                          top="10px"
                          width="50%"
                      >
                        <iframe  :src=structure  style="overflow: auto; width: 100%; height: 850px;"></iframe>

                      </el-dialog>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
             </div>
            <!--              第二块-->



      <div v-show="protable[0].Protein_name != '-'" style="margin: 5px;border: 2px solid #eef1f6">
            <div style="padding-left: 20px;padding-top: 5px;padding-bottom: 10px;margin: 0;
                  font-weight: bold;background-color:#eef1f6 ;"><a style="font-size: 1.1rem;margin: 0;color: #F56C6C">Protein(s) (<a style="color:#F56C6C "v-for="(item,index) in protable[0].Protein_name" >{{item+(index===protable[0].Protein_name.length -1?'':';')}}</a>) information </a>
            </div>
            <el-tabs type="border-card" @tab-click="getRPPS">
              <el-tab-pane v-for="(items,index) in protable" style="font-size: 0.9rem">
                <span slot="label">State{{index+1}}</span>

                <table style="width: 100%">

                  <thead>
                  <tr>
                    <th>Protein(s)</th>
                    <th>Uniprot ID</th>
                    <th>LLPS databases</th>
                    <th>Length</th>
                    <th>IDR</th>
                    <th>LCD</th>
                    <th>Mutation or modification</th>
                    <th>Sequence</th>
                  </tr>
                  </thead>

                  <tr v-for="(item,index) in items.Protein_name">
                    <td>{{items.Protein_name[index]}}</td>
                    <td><a v-show="items.Protein_id[index]=='-'">-</a><a v-show="items.Protein_id[index]!='-'"  v-for="(j,k) in items.Protein_id[index].split(',')" style="color: #0e63bb;" target="_blank" v-bind:href='"https://www.uniprot.org/uniprot/"+j'>{{j+(k===items.Protein_id[index].split(',').length -1?'':';')}}</a></td>

                    <td><a v-show="items.mark[index]=='-'">-</a><a  v-show="items.mark[index]!='-'" v-for="(j,k) in items.mark[index].split(',')" :style="activation(j)" target="_blank" v-bind:href='items.marklink[index].split(",")[k]'>{{j+(k===items.mark[index].split(',').length -1?'':', ')}} </a></td>

                    <td>{{items.Protein_Sequence_length[index]}}</td>
<!--                    <td>{{items.Protein_region[index]}}</td>-->
                    <td>{{items.Protein_idr[index]}}</td>
                    <td>{{items.Protein_lcd[index]}}</td>
                    <td>{{items.Protein_modification[index]}}</td>
                    <td>
                      <a v-show="items.Protein_Sequence[index]=='-'">-</a>
                      <el-popover
                          v-show="items.Protein_Sequence[index]!='-'"
                          title="Protein(s) sequence"
                          trigger="hover"
                          width="630"
                          :content="items.Protein_Sequence[index]"
                      >
                        <el-button slot="reference" size="mini" style="background-color: #eef1f6;color: #0e63bb;font-size: 0.6rem;margin-right: 20px;margin-top: 3px">show</el-button>
                      </el-popover>
                    </td>
                  </tr>
                </table>

              </el-tab-pane>
            </el-tabs>
          </div>


      <div v-if="showlable">
        <div style="margin: 5px;border: 2px solid #eef1f6;">
          <div style="padding-left: 20px;padding-top: 5px;padding-bottom: 10px;margin: 0;
               font-weight: bold;background-color:#eef1f6 ;"><a style="font-size: 1.1rem;margin: 0;color: #E6A23C">PS experiment and description</a>
          </div>
          <el-table
              :data="exptable"
              :cell-style="{background:'white',color: 'black',fontSize: '0.9rem'}"
              :header-cell-style="tableheaderstyle"

              >
            <el-table-column  align= "center" label="Experiment elements">
              <el-table-column
                  key="1"
                  prop="Solute_concentration"
                  label="Solute concentration"
                  align= "center"
                  min-width="130%"
                  v-if="show3"
                 >
              </el-table-column>
              <el-table-column
                  key="2"
                  prop="Salt_concentration"
                  label="Salt concentration"
                  align= "center"
                  min-width="125%"
                  v-if="show4"
              >
              </el-table-column>
              <el-table-column
                  key="3"
                  prop="Buffer"
                  label="Buffer"
                  align= "center"
                  min-width="120%"
                  v-if="show5"
              >
              </el-table-column>
              <el-table-column
                  key="4"
                  prop="Temperature"
                  label="Temperature"
                  align= "center"
                  min-width="98%"
                  v-if="show7"
              >
              </el-table-column>
              <el-table-column
                  key="5"
                  prop="Incubation_time"
                  label="Incubation time"
                  align= "center"
                  min-width="100%"
                  v-if="show1"


              >
              </el-table-column>
              <el-table-column
                  key="6"
                  prop="Detection_method"
                  label="Detection method"
                  align= "center"
                  min-width="100%"
              >
              </el-table-column>
              <el-table-column
                  key="7"
                  prop="Phase_diagram"
                  label="Phase diagram"
                  align= "center"
                  min-width="92%"
                  v-if="show6"
              >
                <template slot-scope="scope">

                  <el-image
                      style="width: 70px; height: 30px"
                      :src="scope.row.Phase_diagram"
                      :preview-src-list="[scope.row.Phase_diagram]">
                    <div slot="error" class="image-slot">
                      <a style="font-size: 0.6rem;align-content: center">-</a>
                    </div>
                  </el-image>

                </template>

              </el-table-column>
              <el-table-column
                  key="8"
                  prop="Morphology"
                  label="Morphology"
                  align= "center"
                  min-width="100%"
                  v-if="show8"
              >
              </el-table-column>
              <el-table-column
                  key="9"
                  prop="other_requirement"
                  label="Other information"
                  align= "center"
                  min-width="110%"
                  v-if="show2"
              >
              </el-table-column>
              <el-table-column
                  key="10"
                  prop="Vivo_or_vitro"
                  label="Vivo/vitro"
                  align= "center"
                  min-width="85%"
              >
              </el-table-column>
            </el-table-column>

            <el-table-column align= "center" label="Description">
              <el-table-column
                  prop="Description"
                  label="Description"
                  align= "center"
                  width="100%"
                  >
                <template slot-scope="scope">
                  <el-popover
                      placement="top-start"
                      title="Description"
                      width="300"
                      trigger="hover"
                      :content=scope.row.Description>
                    <el-button slot="reference" size="mini" style="background-color: #eef1f6;color: #0e63bb;font-size: 0.6rem">show</el-button>
                  </el-popover>
                </template>
              </el-table-column>

              <el-table-column
                  prop="Pmid"
                  label="Source "
                  align= "center"
                  width="130%"
                  :render-header="renderHeader"
              >
                <template slot-scope="scope">
                  <a  style="color: #0e63bb" target="_blank" v-bind:href='scope.row.Pmidlink'>{{scope.row.Pmid}}</a>
                </template>
              </el-table-column>

            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {getdetail,getRPPS} from "@/network/Detail";


export default {

  name: "Detail",
  data() {
    return {
      tableData: [],
      use:{index:0},
      protable:[],
      exptable:[],
      input:null,
      stname:'',
      showlable:false,
      showvalue:null,
      row:null,
      tableData2:[],
      show1:true,
      show2:true,
      show3:true,
      show4:true,
      show5:true,
      show6:true,
      show7:true,
      show8:true,
      isViewPdf20:false,
      structure:''
    }
  },
  created() {
    this.input=this.$route.params.input
    getdetail(this.input).then(res => {
      let a=res.list
      let arr=[]
      let arr2=[]
      let arr4=[]
      let obj={}
      obj.Psid=a[0].fields.rpsid
      obj.Components_type=a[0].fields.components_type
      obj.Rnas=a[0].fields.rnas.split(';|')
      obj.Rna=a[0].fields.rnas.split(';|')
      obj.Rnaother=a[0].fields.rnasother.split(';|')
      obj.Rnaid=a[0].fields.rnaid.split(';|')
      obj.Rnalink=a[0].fields.rnaidlink.split(';|')
      obj.RNA_length=a[0].fields.rna_length.split(';|')
      obj.RNA_Sequence=a[0].fields.rna_sequence.split(';|')
      obj.RNA_Classification=a[0].fields.rna_classification.split(';|')
      obj.RNA_source=a[0].fields.source.split(';|')
      obj.Structure=a[0].fields.structure.split(';')
      arr.push(obj)

      for (let i=0;i<a.length;i++){
        let pro={}

        pro.Rppsid=a[i].fields.rppsid
        pro.Protein_region=a[i].fields.protein_region.split(';|')
        pro.Protein_name=a[i].fields.protein_name.split(';|')
        pro.Protein_id=a[i].fields.protein_id.split(';')

        pro.mark=a[i].fields.mark.split(';')
        pro.marklink=a[i].fields.marklink.split(';')

        pro.Protein_modification=a[i].fields.protein_modification.split(';|')

        pro.Protein_idr=a[i].fields.protein_IDR.split(';|')
        pro.Protein_lcd=a[i].fields.protein_lcd.split(';|')

        pro.Protein_Sequence_length=a[i].fields.protein_sequence_length.split(';|')
        pro.Protein_Sequence=a[i].fields.protein_sequence.split(';')

        arr2.push(pro)

      }for (var i = 0; i < arr2.length - 1; i++) {
        for (var j = i + 1; j < arr2.length; j++) {
          if (arr2[i].Rppsid == arr2[j].Rppsid) {
            arr2.splice(j, 1);
            //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
            j--;
          }
        }
      }
      this.showvalue=arr2[0].Protein_name
      this.protable=arr2
      this.tableData=arr

      for (let k=0;k<arr[0].Rna.length;k++){
        let tab={}
        tab.Rna=arr[0].Rna[k]
        tab.Rnaother=arr[0].Rnaother[k]
        tab.rnaid=arr[0].Rnaid[k]
        tab.rnalink=arr[0].Rnalink[k]
        tab.RNA_length=arr[0].RNA_length[k]
        tab.RNA_Sequence=arr[0].RNA_Sequence[k]
        tab.RNA_Classification=arr[0].RNA_Classification[k]
        tab.RNA_source=arr[0].RNA_source[k]
        tab.structure=arr[0].Structure[k]
        arr4.push(tab)
      }
      this.tableData2=arr4


    })

  },
  methods:{
    renderHeader(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label),
         h(
            "el-popover",
            {
              props: {
                effect: "dark",
                placement: "top-start",
                trigger: "hover",
                content: "Sources include Published, Preprint and Unpublished literatures.\n" +
                    "The entries of unpublished literatures is less reliable."
              }
            },
            [
              h(
                  "i",
                  {
                    slot: "reference",
                    color:'#F56C6C',
                    class: "el-icon-warning"/*elementui的图标*/
                  },
                  ""
              )
            ]
        )
      ]);
    },
    renderHeade(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label),
        h(
            "el-popover",
            {
              props: {
                effect: "dark",
                placement: "top-start",
                trigger: "hover",
                content: "For RNA in vivo, due to the limitations of sequence detection methods, the sequences we provide are annotations from nucleic acid databases such as NCBI and RNACentral.  "
              }
            },
            [
              h(
                  "i",
                  {
                    slot: "reference",
                    color:'#F56C6C',
                    class: "el-icon-warning"/*elementui的图标*/
                  },
                  ""
              )
            ]
        )
      ]);
    },

    tableheaderstyle({row, column, rowIndex, columnIndex}){
          return 'color:black;fontSize:0.9rem;'
    },
    tablepheaderstyle({row, column, rowIndex, columnIndex}){
      if(column.label=='Interact with RNA'){
        return 'background:#F5F7FA;color:darkred;fontSize:0.9rem'
      }else {
        return 'background:#F5F7FA;color:black;fontSize:0.9rem'
      }
    },

    isViewPdf(row){
       this.structure=row.structure
       this.stname=row.Rna

       this.isViewPdf20=true

    },


    getRPPS(tab){
      let a = tab.index
      this.row = this.protable[a].Rppsid

      getRPPS(this.row).then(res => {
        this.showlable=true
        let a=res.list
        let arr=[]
        let b1=0
        let b2=0
        let b3=0
        let b4=0
        let b5=0
        let b6=0
        let b7=0
        let b8=0
        for (let i=0;i<a.length;i++){
          let exp={}
          let c1
          let c2
          let c3
          let c4
          let c5
          let c6
          let c7
          let c8

          exp.Vivo_or_vitro=a[i].fields.in_vitrovivo
          exp.other_requirement=a[i].fields.other_requirement.split('|').join('\n')
          exp.Solute_concentration=a[i].fields.solute_concentration.split('|').join('\n')
          exp.Salt_concentration=a[i].fields.salt_concentration
          exp.Buffer=a[i].fields.buffer
          exp.Temperature=a[i].fields.temperature
          exp.Incubation_time=a[i].fields.incubation_time
          exp.Phase_diagram=a[i].fields.phase_diagram

          if (exp.Incubation_time=='-'){
             c1=0
          }else {
             c1=1
          }
          b1=b1+c1

          if (exp.other_requirement=='-'){
            c2=0
          }else {
            c2=1
          }
          b2=b2+c2

          if (exp.Solute_concentration=='-'){
            c3=0
          }else {
            c3=1
          }
          b3=b3+c3

          if (exp.Salt_concentration=='-'){
            c4=0
          }else {
            c4=1
          }
          b4=b4+c4

          if (exp.Buffer=='-'){
            c5=0
          }else {
            c5=1
          }
          b5=b5+c5

          if (exp.Phase_diagram=='-'){
            c6=0
          }else {
            c6=1
          }
          b6=b6+c6

          if (exp.Temperature=='-'){
            c7=0
          }else {
            c7=1
          }
          b7=b7+c7
          exp.Detection_method=a[i].fields.detection_method.split('|').join('\n')
          exp.Morphology=a[i].fields.morphology.split('|').join('\n')

          if (exp.Morphology=='-'){
            c8=0
          }else {
            c8=1
          }
          b8=b8+c8

          exp.Description=a[i].fields.description
          exp.Pmid=a[i].fields.pmid
          exp.Pmidlink=a[i].fields.pmidlink
          arr.push(exp)
        }
        this.exptable=arr

        if(b1==0){
          this.show1=false
        }
        if(b2==0){
          this.show2=false
        }
        if(b3==0){
          this.show3=false
        }
        if(b4==0){
          this.show4=false
        }
        if(b5==0){
          this.show5=false
        }
        if(b6==0){
          this.show6=false
        }
        if(b7==0){
          this.show7=false
        }
        if(b8==0){
          this.show8=false
        }
      })
    }
  },
  mounted:function () {
    this.timer = setTimeout(()=>{   //设置延迟执行
      this.getRPPS(this.use)
    },800);
  },
  computed:{
    activation(){
      return (j) => { // 使用JavaScript闭包，进行传值操作
        console.log(j)

        if (j.indexOf("PhaSePro") != -1){
          return {'color':'#409EFF'}
        }
        else if (j.indexOf("DrLLPS") != -1){
          return {'color':'#67C23A'}
        }
        else if (j.indexOf("LLPSDB") != -1){
          return {'color':'#E6A23C'}
        }
        else if (j.indexOf("PhaSepDB") != -1){
          return {'color':'#F56C6C'}
        }

      }
    }
}
  // watch:{
  //   protable:{
  //     handler:function (){
  //       this.$nextTick(function (){
  //         this.$refs.rzTable.setCurrentRow(this.protable[0])
  //       })
  //     }
  //   }
  // }
}

</script>

<style scoped>
.el-image{
  margin-right: 30px;
  background-color: white;
}
.el-divider--horizontal{
  margin-top:5px ;
  margin-bottom: 0px;
  margin-left: 0px;
  background: 0 ;
  border-top: 1px  solid #DCDFE6;
}
div
{
  overflow-y:hidden;
  overflow-x: hidden;
  white-space: pre-line;
}
a {
  text-decoration: none;
}
/deep/ th.gutter {
  background-color: #F5F7FA;
}

table{
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
}

table td, table th
{
  border: 1px solid #EBEEF5;
  color: black;
  font-size: 0.9rem;
  padding: 12px 0;
}
table thead th
{
  background-color: #F5F7FA;
  color: black;
  font-size: 0.9rem;
  padding: 12px 0;
}

</style>



